import { getLocationString } from '@rover/react-lib/src/pages/sitter-profile/SitterProfilePage/utils/utils';
import type { SearchCardData } from '@rover/rsdk/src/apiClient/latest/model/searchCardData';
import type { SearchResult } from '@rover/types/src/apiResponses/FetchSearchResponse';
import type { CommonSearchResult } from '@rover/types/src/CommonSearchResult';

export function searchResultToCommonSearchResult(searchResult: SearchResult): CommonSearchResult {
  return {
    opk: searchResult.personOpk,
    shortName: searchResult.shortName,
    avatarUrl: searchResult.defaultImage.medium,
    avatarSmallUrl: searchResult.defaultImage.small,
    caption:
      getLocationString({
        neighborhood: searchResult.neighborhood,
        city: searchResult.city,
        state: searchResult.state,
      }) ?? '',
    isStarSitter: searchResult.profileStatusBadgeData?.slug === 'star-sitter',
    reviewsCount: searchResult.reviewsCount,
    testimonialsCount: searchResult.testimonialsCount,
    ratingsAverage: searchResult.ratingsAverage,
    reviewText: searchResult.reviewText,
    reviewOpk: searchResult.reviewOpk,
    catReviewText: searchResult.catReviewText,
    price: searchResult.price,
    priceUnit: searchResult.priceUnit,
    currencyCode: searchResult.currencyCode,
    currencySymbol: searchResult.currencySymbol,
    priceInCredits: searchResult.priceInCredits ?? null,
    unitAsSentence: searchResult.unitAsSentence,
    repeatClientCount: searchResult.providerProfile.repeatClientCount,
    yearsOfExperience: searchResult.yearsOfExperience,
    engagementSignal: searchResult.engagementSignal ?? null,
    isBestMatch: searchResult.isBestMatch,
    maybeBestMatch: searchResult.maybeBestMatch,
    popoverDebugData: searchResult.popoverDebugData,
    primaryBadgeData: searchResult.primaryBadgeData,
    cancellationPolicy: searchResult.cancellationPolicy,
    images: searchResult.images,
    personalizationTags: searchResult.personalizationTags ?? null,
  };
}

export function searchCardDataToCommonSearchResult(
  searchCardData: SearchCardData
): CommonSearchResult {
  return {
    opk: searchCardData.providerOpk,
    shortName: searchCardData.title,
    avatarUrl: searchCardData.avatarUrl,
    avatarSmallUrl: searchCardData.avatarUrl,
    caption: searchCardData.caption,
    isStarSitter: searchCardData.badges.some((badge) => badge.slug === 'star-sitter'),
    reviewsCount: searchCardData.reviewsCount,
    ratingsAverage: searchCardData.ratingsAverage,
    reviewText: searchCardData.reviewText,
    reviewOpk: null,
    catReviewText: searchCardData.catReviewText,
    price: searchCardData.price,
    priceUnit: searchCardData.priceUnit,
    currencyCode: searchCardData.currencyCode,
    currencySymbol: searchCardData.currencySymbol,
    priceInCredits: searchCardData.priceInCredits,
    unitAsSentence: searchCardData.priceUnit,
    repeatClientCount: Number(searchCardData.repeatClients),
    yearsOfExperience:
      searchCardData.providerNumbers?.icon === 'Trophy' ? searchCardData.providerNumbers.label : '',
    engagementSignal: searchCardData.engagementSignal,
    isBestMatch: searchCardData.isBestMatch,
    maybeBestMatch: searchCardData.maybeBestMatch,
    popoverDebugData: null,
    primaryBadgeData: searchCardData.avatarBadgeUrl
      ? {
          showOnSearch: true,
          title: '',
          content: '',
          slug: 'background-check',
          imageUrl: `https:${searchCardData.avatarBadgeUrl}`,
        }
      : undefined,
    personalizationTags: searchCardData.personalizationTags ?? null,
    images: searchCardData.providerGalleryImages
      ? {
          galleryImages: searchCardData.providerGalleryImages.galleryImages.map((img) => ({
            index: Number(img.index),
            largeUncropped: img.largeUncropped,
            smallImage: '',
          })),
          imageCount: searchCardData.providerGalleryImages.imageCount,
        }
      : null,
  };
}
